import { render, staticRenderFns } from "./ModalStaff.vue?vue&type=template&id=53600a3f&scoped=true&"
import script from "./ModalStaff.vue?vue&type=script&lang=js&"
export * from "./ModalStaff.vue?vue&type=script&lang=js&"
import style0 from "./ModalStaff.vue?vue&type=style&index=0&id=53600a3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53600a3f",
  null
  
)

export default component.exports